import { IonButton, IonCol, IonInput, IonItem, IonLoading, IonRow, IonSelect, IonSelectOption, IonIcon } from "@ionic/react"
import { checkmark } from "ionicons/icons"
import { useEffect, useState } from "react"
import { Redirect, useHistory, useParams } from "react-router"
import { API_URL } from "../../actions/settings"
import { useAppSelector } from "../../Hooks"
import { selectUser } from "../../reducers/UserReducer"
import CheckRole from "../extras/CheckRole"
import useForm from "../../utils/useForm"
import "./VirtualMeterForm.css"
import NotificationPopUp from "../extras/NotificationPopUp"

interface Props{
    edit:boolean
}

interface Params {
  id: string;
}


const startingForm = {
    type:'',
    name:'',
    unitofmeasure:'',
    source_meter_ids:[]  
}

const startingErrors = {
    type:"",
    name:"",
    unitofmeasure:"",
    source_meter_ids:""
}

async function getMeter(token:any,id:string) {

    return fetch(`${API_URL}/internal_meter_data/${id}/form`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },

    })
      .then(data => data.json())
   }


async function getMeterTypes(token:any) {

    return fetch(`${API_URL}/energystar/meters/types`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      }

    })
      .then(data => data.json())
}

async function getMeters(token: string, id: string) {
  return fetch(`${API_URL}/buildings/${id}/non_virtual_meters`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) =>
    res.json());
}

async function submitMeter(token: string,data: any,id:any,method:string) {
  return fetch(`${API_URL}/energystar/virtual_meters/${id}`, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify(data),
  }).then((data) => data.json());
}


const validate = (input:string, value:any, type:any) => {
    switch (input){
        case "name":
            if (value === '' || value.length < 3){
                return {'name':"Name cannot be less than 3 characters"}
            }
            else {
                return {'name':''}
            }
        case "type":
            if (value === ''){
                return {'type':"Please Select A Type"}
            }
            else {
                return {'type':''}
            }
        case "unitofmeasure":
            if (value === ''){
                return {'unitofmeasure':"Please Select A Unit of Measure"}
            }
            else if ([11,12,13].includes(type) && value !== 'kWh (thousand Watt-hours)'){
                return {'unitofmeasure':"Not a Valid Unit for Meter Type"}
            }
            else if ([19,21].includes(type) && value !== 'therms'){
                return {'unitofmeasure':"Not a Valid Unit for Meter Type"}
            }
            else if ([27,28,29,30,31,32,33].includes(type) && !['Gallons (US)','KGal (thousand gallons) (US)','MGal (million gallons) (US)','Million Gallons per Day'].includes(value)){
                return {'unitofmeasure':"Not a Valid Unit for Meter Type"}
            }
            else {
                return {'unitofmeasure':''}
            }
        default:
            break;
    }
}



const VirtualMeterForm:React.FC<Props> = ({edit}) =>{
    const { id } = useParams<Params>();
    const { form, handleFormChange, errors, resetForm, validateForm } = useForm(
        startingForm,
        startingErrors,
        validate,

    )
    // const [errors, setErrors] = useState(startingErrors)
    const [types, setTypes] = useState([])
    const user = useAppSelector(selectUser)
    const [meters,setMeters] = useState([])
    const [selected,setSelected] = useState<any>([])
    const history = useHistory()

    const handleTypes = async () =>{
        const token = localStorage.getItem('token') || ""
        const res = await getMeterTypes(`Token ${token.slice(1,-1)}`)
        setTypes(res.types)
    }

    const handleSubmit = async () =>{
        const token = localStorage.getItem('token') || ""
        const method = edit ? "PUT" : "POST"        
        form.source_meter_ids = selected
        const valid = validateForm()
        if (valid && selected.length > 1){
            const res = await submitMeter(`Token ${token.slice(1,-1)}`,form,id,method)            
            if(res.status==='error'){
                NotificationPopUp('Error',res.detail, 'Error Creating Virtual Meter')
            }
            else{                
                NotificationPopUp('Success',`${edit ? 'Meter Updated':'Meter Created'}`, 'Success')
                resetForm()
                setSelected([])                
                history.push(`/?id=${res.data.building}&sec=buildings&t=meters&m=virtual`)
            }

        }
        else if(selected.length<=1){
            NotificationPopUp('Error','Select more than 1 meter.', 'Select Meters')
        }        
    }


    




    useEffect (()=>{
        const handleMeters = async (id:string) => {
            const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
            const res = await getMeters(token, id);
            if(res.status==='error'){
                console.log(res.error)
            }
            else setMeters(res.data)
        };

        if(edit){
            const handleMeterData = async () => {
                const token = localStorage.getItem('token') || ""
                const res = await getMeter(`Token ${token.slice(1,-1)}`,id)                
                if(res.status === 'error'){
                    console.log(res.error)
                    NotificationPopUp('Error',res.error, 'Error Loading Meter Data')                
                }
                else {
                    handleMeters(res.data.building)
                    handleFormChange(res.data.type.id,'type')
                    handleFormChange(res.data.name,'name')
                    handleFormChange(res.data.unitofmeasure,'unitofmeasure')
                    setSelected(res.data.source_meter_ids)                             
                }
            }

            handleMeterData()
            
        }
        


        handleTypes()
        if(!edit){            
            handleMeters(id)
        }
        //ignore the warning
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    },[id,edit])

    if (user.first_name===""){
        return(
            <IonLoading
        cssClass='my-custom-class'
        isOpen={user.first_name===""}
        message={'Loading...'}
        spinner='bubbles'
      />
        )
    }

    if(!CheckRole(user,['Admin','Supervisor'])){
        return <Redirect to="/403"/>
    }


    return(
        <div className="virtual-meter-form">
            
        <h2> {edit? 'Edit ': 'Create '}Virtual Meter</h2>
        <p> Virtual meters are used to combine 2 or more utility/internal meters. The source meters will no longer be used for any computations or reports. </p>

        <form className="text-dark-blue">
            <IonRow>

                <IonCol>
                    <IonItem lines="none">
                        <IonInput label='Name' labelPlacement='stacked' className={errors.name === '' ? "valid":' ion-invalid ion-touched'}
                            errorText={errors.name}
                            aria-labelledby="Name" type="text" required value={form.name} placeholder="Name" onIonChange={e => (handleFormChange( e.detail.value!,'name'))}/>
                        {/* <div className="error-detail" style={{width:'100%'}}>{errors.name}</div> */}
                    </IonItem>
                </IonCol>
                <IonCol>
                    <IonItem lines="none">
                        <IonSelect label='Type' labelPlacement='stacked' className={errors.type === '' ? "valid":' ion-invalid ion-touched'} errorText={errors.type} aria-label='Type' interface="popover" interfaceOptions={{cssClass: 'fit-popover'}} value={form.type} placeholder="Meter Type" onIonChange={e => (handleFormChange( e.detail.value!,'type'))}>
                            {types.map((type)=>{
                                return(
                                    <IonSelectOption key={type['id']} value={type['id']}>{type['name']}</IonSelectOption>
                                )
                            })}
                        </IonSelect>                        
                    </IonItem>
                </IonCol>                

            </IonRow>
            <IonRow>
                <IonCol>
                    <IonItem lines="none">
                        <IonSelect label='Unit of Measure' labelPlacement='stacked' errorText={errors.unitofmeasure} className={errors.unitofmeasure === '' ? "valid":' ion-invalid ion-touched'} interface='popover' interfaceOptions={{cssClass: 'fit-popover'}} aria-label="Unit of Measure" value={form.unitofmeasure} placeholder="Units" onIonChange={e => (handleFormChange( e.detail.value!,'unitofmeasure'))}>
                            <IonSelectOption>cf (cubic feet)</IonSelectOption>
                            <IonSelectOption>ccf (hundred cubic feet)</IonSelectOption>
                            <IonSelectOption>cGal (thousand gallons) (US)</IonSelectOption>
                            <IonSelectOption>cm (Cubic meters)</IonSelectOption>
                            <IonSelectOption>eKWh (Equivalent Kilowatt hour')</IonSelectOption>
                            <IonSelectOption>Gallons (US)</IonSelectOption>
                            <IonSelectOption>GJ</IonSelectOption>
                            <IonSelectOption>kBtu (thousand Btu)</IonSelectOption>
                            <IonSelectOption>kcf (thousand cubic feet)</IonSelectOption>
                            <IonSelectOption>kcm (thousand cubic meters)</IonSelectOption>
                            <IonSelectOption>KGal (thousand gallons) (US)</IonSelectOption>
                            <IonSelectOption>Kilogram</IonSelectOption>
                            <IonSelectOption>KLbs. (thousand pounds)</IonSelectOption>
                            <IonSelectOption>kWh (thousand Watt-hours)</IonSelectOption>
                            <IonSelectOption>kW</IonSelectOption>                            
                            <IonSelectOption>Liters</IonSelectOption>                            
                            <IonSelectOption>MBtu (million Btu)</IonSelectOption>
                            <IonSelectOption>MGal (million gallons) (US)</IonSelectOption>
                            <IonSelectOption>Million Gallons per Day</IonSelectOption>
                            <IonSelectOption>MLbs. (million pounds)</IonSelectOption>
                            <IonSelectOption>pounds</IonSelectOption>
                            <IonSelectOption>therms</IonSelectOption>
                            <IonSelectOption>ton hours</IonSelectOption>

                        </IonSelect>                        
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol style={{border:'1px solid grey', borderRadius:'0.2rem'}}>
                    <h4 className="text-white">Select Meters to Include: {}</h4>                    
                    <IonRow>
                        {meters.map(meter => {
                            const isSelected = selected.includes(meter['id']);
                            return(
                                <IonCol 
                                    className={`meter-select-option ${isSelected ? 'selected' : ''}`} 
                                    key={meter['id']} 
                                    size="3"
                                    onClick={() => {
                                        if (isSelected) {
                                            setSelected(selected.filter((id:string) => id !== meter['id']));
                                        } else {
                                            setSelected([...selected, meter['id']]);
                                        }
                                    }}
                                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                    <div>
                                        <span>{meter['name']} {!meter['building']  && !meter['inuse'] ? '(INACTIVE)':""}</span>
                                        <div style={{fontSize:'0.7rem',color:'grey'}}>{meter['building'] ? 'Internal Meter' : 'Utility Meter'} -- {meter['type']['name']}</div>
                                    </div>
                                    <div style={{ width: '24px', height: '24px' }}>
                                        {isSelected && <IonIcon icon={checkmark} />}
                                    </div>
                                </IonCol>)}
                            )                                
                            }
                    </IonRow>
                </IonCol>
            </IonRow>

            <div className="btn-wrapper">
                <IonButton onClick={handleSubmit}>
                    {edit? "Edit Meter":"Create Meter"}   
                </IonButton>
            </div>           
        
        </form>
        </div>
    )
}

export default VirtualMeterForm